const UsefulLinksListing = ({ groups }) => {
  return (
    <div className="grid grid-cols-12 gap-6">
      {groups.map(({ key, groupHeading, groupContent }) => {
        return (
          <div key={key} className="col-span-12 space-y-4 lg:col-span-4">
            <h2 className="font-sans text-lg font-bold lg:text-xl">
              {groupHeading}
            </h2>
            <div
              className="body-text-sm not-prose space-y-1"
              dangerouslySetInnerHTML={{ __html: groupContent }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default UsefulLinksListing;
